import React from "react"

const widthClassByVariant = {
  default: "max-w-2xl",
  wide: "max-w-4xl",
  full: "max-w-none",
}

const PageWrapper = ({
  header = null,
  title = null,
  headerLeft = null,
  headerRight = null,
  children,
  variant = "default",
  background = "",
  className = "",
  contentClassName = "",
}) => {
  const widthClass = widthClassByVariant[variant] || widthClassByVariant.default
  const hasStructuredHeader = Boolean(title || headerLeft || headerRight)

  const hasPxOverride = /\b!?px-\S+/.test(className) || /\b!?p[lr]-\S+/.test(className)
  const hasPyOverride = /\b!?py-\S+/.test(className) || /\b!?p[tb]-\S+/.test(className)

  const basePx = hasPxOverride ? "" : "px-6"
  const basePy = hasPyOverride ? "" : "py-8"

  return (
    <div className={`h-screen ${background} ${basePx} ${basePy} flex justify-center overflow-hidden ${className}`}>
      <div className={`w-full ${widthClass} flex flex-col ${contentClassName}  overflow-hidden`}>
        {hasStructuredHeader ? (
          <div className="relative h-14 mb-6 flex-shrink-0">
            <div className="absolute left-0 inset-y-0 my-auto w-12 h-12 flex items-center justify-center z-10">
              {headerLeft || <span className="inline-block w-6 h-6" />}
            </div>
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 text-center">
              {typeof title === "string" ? (
                <div className="text-[28px] font-bold text-light-default">{title}</div>
              ) : (
                title
              )}
            </div>
            <div className="absolute right-0 inset-y-0 my-auto w-12 h-12 flex items-center justify-center z-10">
              {headerRight || <span className="inline-block w-6 h-6" />}
            </div>
          </div>
        ) : header ? (
          <div className="mb-6 flex-shrink-0">{header}</div>
        ) : (
          <div className="h-4 flex-shrink-0" />
        )}
        <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hide">
          {children}
        </div>
      </div>
    </div>
  )
}

export default PageWrapper
